<script>
    import LayerListSwitch from "../LayerList/LayerListSwitch.svelte";

    export let typeData;
    export let categoryData;

    export let alertType = "";
    
    let typeExists = typeData.exists;

    let exists = categoryData.exists;
    let visible = categoryData.visible;
</script>

<LayerListSwitch
    label={categoryData.name}
    disabled={!$typeExists || !$exists}
    data-alerttype={alertType}
    data-subcategory={categoryData.name}
    bind:checked={$visible}
    on:change
    marginLeft={40}
    />